module.exports = __webpack_public_path__ + "img/banner_about.8fd0b103.png";